import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EFPicture from '@elem/compCommon/EFPicture';

import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('theProduct.ListA3');
    return (
        <section className={`temp-section-4 ${styles.comp}`} id="section-4">
            <EcoSpace />
            {/* <EcoSectionCommon title={t('title')} desc={t('desc')} /> */}
            {/* <EcoSpaceSmall /> */}
            <div className="awards-box">
                <div className="awards-img">
                    <EFPicture
                        src="https://websiteoss.ecoflow.com/upload/image/1748509932220/Frame%201000009086%20(1).jpg"
                        srcPad="https://websiteoss.ecoflow.com/upload/image/1748509932220/Frame%201000009086%20(1).jpg"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1748509932028/%E6%AD%A3%E5%BC%8F.jpg"
                    />
                </div>
            </div>

            <EcoSpace />
        </section>
    );
}
